import './footer.css';
import TabFooter from '../tabFooter/tabFooter';

const tabFooter = new TabFooter();